import { useMemo } from 'react'
import { useTar } from '@/modules'
import { LinkedInIcon } from '@duck/ui'
import { ArrowRightIcon } from '@heroicons/react/24/outline'

interface LinkedInSignInButtonProps {
  onClick: () => void
  isDisabled: boolean
}

export const LinkedInSignInButton = ({ onClick, isDisabled }: LinkedInSignInButtonProps) => {
  const { t } = useTar()
  const isLastUsed = useMemo(() => window.localStorage.getItem('last_auth_provider') === 'linkedin', [])

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={`group relative flex h-[54px] w-full items-center gap-3 rounded-xl border border-border/50 bg-background px-4 text-start text-sm font-medium text-foreground transition-[border-color,box-shadow,transform,background-color] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${
        isDisabled
          ? 'cursor-not-allowed opacity-50'
          : 'hover:-translate-y-px hover:border-accent/60 hover:bg-card hover:shadow-[0_0_0_1px_hsl(var(--color-accent)/0.25),0_0_24px_-6px_hsl(var(--color-accent)/0.5)]'
      }`}
    >
      <span className="flex h-8 w-8 flex-none items-center justify-center rounded-lg border border-border/50 bg-foreground/[0.04]">
        <LinkedInIcon size={18} className="h-[18px] w-[18px]" />
      </span>
      <span className="flex-1">{t('common.continueWithLinkedIn')}</span>
      {isLastUsed && (
        <span className="rounded border border-accent/40 bg-accent/10 px-1.5 py-[3px] font-jet-mono text-[8.5px] uppercase tracking-[1px] text-accent">
          {t('auth.lastUsed')}
        </span>
      )}
      <ArrowRightIcon
        className="h-4 w-4 flex-none text-muted-foreground transition-transform duration-200 group-hover:translate-x-0.5 group-hover:text-accent rtl:rotate-180 rtl:group-hover:-translate-x-0.5"
        aria-hidden="true"
      />
    </button>
  )
}
